import { useState } from 'react'
import { useMutation } from '@apollo/client'
import { Toast } from 'lib/ui/components'
import { PwaFormField, processPwaForm } from 'services/sendFormData'

export const usePwaForm = (formId: string) => {
  const [status, seStatus] = useState<'success' | ''>('')
  const isSuccess = status === 'success'

  function submitForm (formFields: PwaFormField[], handleSuccess?: () => void) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    sendPwaForm({
      variables: {
        form_id: formId,
        form_fields: formFields
      }
    }).then((result) => {
      if (result) {
        if (!result.data.processPwaForm.success) {
          Toast.toastFailure({ messageId: 'pwa.form.error', message: result.data.processPwaForm.message })
        } else {
          seStatus('success')
          Toast.toastSuccess({ messageId: 'pwa.form.success' })
          handleSuccess?.()
        }
      }
    })
  }

  const handleError = (error: any) => {
    // eslint-disable-next-line no-console
    console.log(error)
    Toast.toastFailure({ messageId: 'toast.errorWhileSaving.message' })
  }

  const [sendPwaForm, { loading: isFetching }] = useMutation(processPwaForm, { onError: handleError })

  return {
    submitForm,
    isSuccess,
    isFetching
  }
}
